/* index.tsx generated by @compiled/babel-plugin v0.37.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1ule%7Bdisplay%3Ablock%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5ral1dfr%7B-o-object-fit%3Acover%3Bobject-fit%3Acover%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4t3i1osq%7Bheight%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bahesu3%7Bjustify-content%3Aflex-end%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1pbykb7n%7Bz-index%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._rjxppxbi%7Binset-inline-end%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._152tpxbi%7Binset-block-start%3Avar(--ds-space-200%2C1pc)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswstnw%7Bposition%3Aabsolute%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkhfxm%7Bbackground-color%3Avar(--ds-surface-sunken%2C%23f8f8f8)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ein1kw7%7Bborder-end-end-radius%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._5fbc1kw7%7Bborder-start-end-radius%3Ainherit%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bah1fhb%7Bjustify-content%3Astretch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._4cvr1fhb%7Balign-items%3Astretch%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._syaz1rpy%7Bcolor%3Avar(--ds-text-subtlest%2C%236b6e76)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q511ejb%7Bpadding-block-start%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1c0q%7Bwidth%3A133px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._i0dl1wug%7Bflex-basis%3Aauto%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zidpf%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlidpf%7Bflex-grow%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bfhkhp5a%7Bbackground-color%3Avar(--ds-surface-raised%2C%23fff)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._y4ti1jfw%7Bpadding-inline-end%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._bozg1jfw%7Bpadding-inline-start%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._85i51ejb%7Bpadding-block-end%3Avar(--ds-space-300%2C24px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1q511jfw%7Bpadding-block-start%3Avar(--ds-space-500%2C40px)%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tkeidpf%7Bmin-height%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1ul9idpf%7Bmin-width%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2lx21bp4%7Bflex-direction%3Acolumn%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._i0dl1ssb%7Bflex-basis%3A50%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1o9zkb7n%7Bflex-shrink%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._16jlkb7n%7Bflex-grow%3A1%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._kqswh2mm%7Bposition%3Arelative%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1tke1pna%7Bmin-height%3A420px%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1bsb1osq%7Bwidth%3A100%25%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1e0c1txw%7Bdisplay%3Aflex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._18m915vq%7Boverflow-y%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1reo15vq%7Boverflow-x%3Ahidden%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2rko1kw7%7Bborder-radius%3Ainherit%7D");
import React, { useCallback, useState } from 'react';
import Button from '@atlaskit/button/default/button';
import Heading from '@atlaskit/heading/heading';
import Image from '@atlaskit/image';
import Modal from '@atlaskit/modal-dialog/modal-dialog';
import { CloseButton } from '@atlaskit/modal-dialog/close-button';
import ModalTransition from '@atlaskit/modal-dialog/modal-transition';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Hide } from '@atlaskit/primitives/responsive/hide';
import { FormattedMessage } from 'react-intl';
import { useRovoAppification } from '@townsquare/rovo/appification';
import { HomeScreenSpaceFlagsChangeBoarding } from '../../placements';
import headerDark from './assets/header-dark.svg';
import headerLight from './assets/header-light.svg';
import illustrationDark from './assets/illustration-dark.svg';
import illustrationLight from './assets/illustration-light.svg';
const styles = {
  modalContainer: "_2rko1kw7 _1reo15vq _18m915vq _1e0c1txw _1bsb1osq _1tke1pna _kqswh2mm",
  leftHalf: "_16jlkb7n _1o9zkb7n _i0dl1ssb _1e0c1txw _2lx21bp4 _1ul9idpf _1tkeidpf _1q511jfw _85i51ejb _bozg1jfw _y4ti1jfw _bfhkhp5a",
  headerImage: "_16jlidpf _1o9zidpf _i0dl1wug _1bsb1c0q",
  content: "_16jlkb7n _1o9zkb7n _i0dl1wug _1q511ejb",
  bodyText: "_syaz1rpy",
  rightHalf: "_16jlkb7n _1o9zkb7n _i0dl1ssb _1reo15vq _18m915vq _1e0c1txw _4cvr1fhb _1bah1fhb _1ul9idpf _kqswh2mm _5fbc1kw7 _1ein1kw7 _bfhkhfxm",
  closeButton: "_kqswstnw _152tpxbi _rjxppxbi _1pbykb7n",
  footer: "_16jlidpf _1o9zidpf _i0dl1wug _1e0c1txw _1bahesu3 _1q511ejb",
  illustration: "_1bsb1osq _4t3i1osq _5ral1dfr _1e0c1ule"
};
type RovoAppificationModalProps = {
  dismiss: () => void;
};
function RovoAppificationModal({
  dismiss
}: RovoAppificationModalProps): React.JSX.Element {
  const [isOpen, setIsOpen] = useState(true);
  const onClose = useCallback(() => {
    setIsOpen(false);
    dismiss();
  }, [dismiss]);
  return <ModalTransition>
			{isOpen && <Modal onClose={onClose} width="large" testId="rovo-appification-modal">
					<Box xcss={styles.modalContainer}>
						<Box xcss={styles.closeButton}>
							<CloseButton onClick={onClose} label="Close modal" />
						</Box>
						<Box xcss={styles.leftHalf}>
							<Box xcss={styles.headerImage}>
								<Image src={headerLight} srcDark={headerDark} alt="" testId="rovo-appification-modal-header" />
							</Box>
							<Box xcss={styles.content}>
								<Stack space="space.300">
									<Heading size="medium">
										<FormattedMessage id="townsquare.post-office.rovo-appification-modal.title" description="Title for the Rovo appification modal informing users that Atlassian Home has been upgraded to the Rovo app" defaultMessage="Atlassian Home is now the Rovo app" />
									</Heading>
									<Box xcss={styles.bodyText}>
										<FormattedMessage id="townsquare.post-office.rovo-appification-modal.body-paragraph-1" description="First paragraph explaining the Rovo app upgrade from Home" defaultMessage="We've upgraded your Home to the Rovo app, a faster way to find information and take action." />
									</Box>
									<Box xcss={styles.bodyText}>
										<FormattedMessage id="townsquare.post-office.rovo-appification-modal.body-paragraph-2" description="Second paragraph explaining the features available in the Rovo app" defaultMessage="You can now easily access Search, Chat and Agents alongside your familiar starred items, recent work and notifications - all in one place." />
									</Box>
								</Stack>
							</Box>
							<Box xcss={styles.footer}>
								<Button testId="rovo-appification-modal-continue" appearance="primary" onClick={onClose}>
									<FormattedMessage id="townsquare.post-office.rovo-appification-modal.continue-button" description="Continue button label for the Rovo appification modal" defaultMessage="Continue" />
								</Button>
							</Box>
						</Box>
						<Hide below="sm">
							<Box xcss={styles.rightHalf}>
								<Box xcss={styles.illustration}>
									<Image src={illustrationLight} srcDark={illustrationDark} alt="" testId="rovo-appification-modal-illustration" />
								</Box>
							</Box>
						</Hide>
					</Box>
				</Modal>}
		</ModalTransition>;
}
export default function RovoAppificationChangeboarding(): React.JSX.Element | null {
  const {
    rovoAppificationState
  } = useRovoAppification();
  if (rovoAppificationState === 'enabled') {
    return <HomeScreenSpaceFlagsChangeBoarding featureId="rovo-appification-modal">
				{({
        onDismiss
      }) => <RovoAppificationModal dismiss={onDismiss} />}
			</HomeScreenSpaceFlagsChangeBoarding>;
  }
  return null;
}